module.exports = __webpack_public_path__ + "static/media/roundedshoulder_severe_right.b74a77bc.png";